export default __webpack_public_path__ + "static/media/Cattura10.9dda5146.jpg";